import { affiliateApi } from '../lib/axios';

export enum AffiliateTaxProfileFormType {
  W9 = 'W9',
  W8BEN = 'W8BEN',
}

export enum AffiliateTaxProfileEntityType {
  INDIVIDUAL = 'INDIVIDUAL',
  SOLE_PROPRIETOR = 'SOLE_PROPRIETOR',
  SINGLE_MEMBER_LLC = 'SINGLE_MEMBER_LLC',
  MULTI_MEMBER_LLC = 'MULTI_MEMBER_LLC',
  C_CORP = 'C_CORP',
  S_CORP = 'S_CORP',
  PARTNERSHIP = 'PARTNERSHIP',
  TRUST = 'TRUST',
}

export interface TaxProfileAddress {
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  // W-8BEN specific fields
  permanent?: {
    street: string;
    city: string;
    state?: string;
    zipCode?: string;
    country: string;
  };
  mailing?: {
    street: string;
    city: string;
    state?: string;
    zipCode?: string;
    country: string;
  };
  countryOfCitizenship?: string;
  countryOfTaxResidence?: string;
}

export interface TaxProfile {
  id: string;
  affiliateId: string;
  taxYear: number;
  formType: AffiliateTaxProfileFormType;
  legalName: string;
  businessName?: string;
  entityType: AffiliateTaxProfileEntityType;
  taxCountry: string;
  address: TaxProfileAddress;
  taxId: string;
  taxIdLast4: string;
  status: 'MISSING' | 'COMPLETE';
  createdAt: string;
  updatedAt: string;
}

export interface CreateTaxProfilePayload {
  taxYear: number;
  formType: AffiliateTaxProfileFormType;
  legalName: string;
  businessName?: string;
  entityType: AffiliateTaxProfileEntityType;
  taxCountry: string;
  address: TaxProfileAddress;
  taxId?: string; // Required for W-9, optional for W-8BEN
  signature?: string; // Typed signature for certification
}

export interface UpdateTaxProfilePayload {
  taxYear?: number;
  formType?: AffiliateTaxProfileFormType;
  legalName?: string;
  businessName?: string;
  entityType?: AffiliateTaxProfileEntityType;
  taxCountry?: string;
  address?: TaxProfileAddress;
  taxId?: string;
}

export const taxProfileService = {
  async create(data: CreateTaxProfilePayload): Promise<TaxProfile> {
    const response = await affiliateApi.post('/affiliate-tax-profile', data);
    return response.data;
  },

  async update(id: string, data: UpdateTaxProfilePayload): Promise<TaxProfile> {
    const response = await affiliateApi.patch(`/affiliate-tax-profile/${id}`, data);
    return response.data;
  },

  async findAll(): Promise<TaxProfile[]> {
    const response = await affiliateApi.get('/affiliate-tax-profile');
    return response.data;
  },

  async findByYear(year: number): Promise<TaxProfile | null> {
    const response = await affiliateApi.get(`/affiliate-tax-profile/by-year?year=${year}`);
    return response.data;
  },

  async findOne(id: string): Promise<TaxProfile> {
    const response = await affiliateApi.get(`/affiliate-tax-profile/${id}`);
    return response.data;
  },
};
